export const sasCartApi = {
  billing: 'customer/v1/subscription-cart/billing',
  cart: 'customer/v1/subscription-cart',
  cartAmount: 'customer/v1/subscription-cart/:cartId/quantity/total',
  cartDetail: 'customer/v1/subscription-cart-detail',
  mergeAnonymousCart: 'customer/v1/subscription-cart/merge/anonymous/customer',
  thermometer: 'customer/v1/subscription-cart/:cartId/thermometer',
  validateProductInCart: 'customer/v1/subscription-cart/:cartId/item/:productId',
};
